import { get,post, put, destroy,getOne } from '../apis/httpClient'

export const getUsers = (params) => get('/api/v1/user/paging', params)
export const updateUser = (body) => put('/api/v1/user/update', body)
export const detailUser = (query) => getOne(`/api/v1/user/detail/${query}`)
export const deleteUser = (body) => destroy('/api/v1/user/delete', body)
export const createUser=(body)=>post('/api/v1/user/create',body)
export const updateProfile=(body)=>put(`/api/v1/user/updateProfile`,body)

